(() => {
 function init(root = document) {
  root.querySelectorAll('[data-bg-product-rail]').forEach(host => {
   if (host.dataset.railReady) return;
   host.dataset.railReady = 'true';
   const rail = host.querySelector('#BGHomeProducts');
   const controls = host.querySelector('.bg-home-rail-controls');
   const prev = host.querySelector('[data-rail-prev]');
   const next = host.querySelector('[data-rail-next]');
   const status = host.querySelector('[data-rail-status]');
   controls.hidden = false;
   function update() {
    const max = rail.scrollWidth - rail.clientWidth;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max - 2;
    const cards = [...rail.children];
    const left = rail.getBoundingClientRect().left;
    const visible = cards.map((card,index) => ({index,rect:card.getBoundingClientRect()})).filter(c => c.rect.right > left+8 && c.rect.left < left+rail.clientWidth-8);
    if (visible.length) status.textContent = `${visible[0].index+1}–${visible[visible.length-1].index+1} of ${cards.length} pieces`;
   }
   function move(direction) {
    rail.scrollBy({left:direction*rail.clientWidth*.9,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   }
   prev.addEventListener('click',()=>move(-1));
   next.addEventListener('click',()=>move(1));
   rail.addEventListener('scroll',update,{passive:true});
   rail.addEventListener('keydown',e=>{if(e.target===rail&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowLeft'?-1:1);}});
   const observer = new ResizeObserver(update);observer.observe(rail);
   document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(host))observer.disconnect();},{once:true});
   update();
  });
 }
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
